function pickString(data: Record<string, unknown>, ...keys: string[]): string | undefined {
  for (const k of keys) {
    const v = data[k]
    if (typeof v === 'string' && v.trim().length > 0) return v.trim()
  }
  return undefined
}

export default class Recommendation {
  _id: string
  user_id: string
  user_small_avatar_url?: string
  user_large_avatar_url?: string
  /** Public / alternate recommender row shape (mirrors `rec_references` extractors). */
  small_avatar_url?: string
  large_avatar_url?: string
  /**
   * 'explicit' | 'enriched' when the user actively chose to recommend this place.
   * Absent (undefined) on implicit rows created by post-save auto-add.
   * Used by the facepile to match rec_count_breakdown.explicit_recommendations.
   */
  recommendation_source?: string
  location_id: number | undefined
  created_at: Date
  /** Preserved when API nests profile fields under `user` (not flattened onto the row). */
  user?: Record<string, unknown>

  constructor(data: Record<string, unknown>) {
    this._id = (data._id as string) ?? ''
    let resolvedUserId = pickString(data, 'user_id', 'userId')
    if (!resolvedUserId && data.user && typeof data.user === 'object' && !Array.isArray(data.user)) {
      const uid = (data.user as { _id?: unknown })._id
      if (uid != null && uid !== '') resolvedUserId = String(uid)
    }
    this.user_id = resolvedUserId ?? ''

    this.user_small_avatar_url = pickString(data, 'user_small_avatar_url', 'userSmallAvatarUrl')
    this.user_large_avatar_url = pickString(data, 'user_large_avatar_url', 'userLargeAvatarUrl')
    this.small_avatar_url = pickString(data, 'small_avatar_url', 'smallAvatarUrl')
    this.large_avatar_url = pickString(data, 'large_avatar_url', 'largeAvatarUrl')
    this.recommendation_source = pickString(data, 'recommendation_source', 'recommendationSource')

    if (data.user && typeof data.user === 'object' && !Array.isArray(data.user)) {
      this.user = data.user as Record<string, unknown>
    }

    this.location_id = data.location_id as number | undefined
    this.created_at = new Date(data.created_at as string)
  }
}
